var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let NetworkCard = class NetworkCard extends LitElement {
    constructor() {
        super(...arguments);
        this.logoUrl = null;
        this.selected = false;
    }
    handleClick() {
        this.dispatchEvent(new CustomEvent('network-click', {
            detail: this.network,
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        const { name, description } = this.network;
        return html `
      <div class="layout" @click=${this.handleClick}>
        <div class="logo">
          ${this.logoUrl
            ? html `<img src=${this.logoUrl} alt="" />`
            : ''}
        </div>
        <div class="body">
          <div class="name" title=${name}>${name}</div>
          ${description?.trim()
            ? html `<div class="description">${description}</div>`
            : ''}
        </div>
      </div>
    `;
    }
};
NetworkCard.styles = css `
    :host {
      display: block;
      padding: 10px 12px;
      border: 1px solid #d5dde5;
      border-radius: 8px;
      background: #fff;
      font-family: inherit;
      color: #333;
      box-sizing: border-box;
      cursor: pointer;
      transition:
        background 0.15s,
        border-color 0.15s,
        box-shadow 0.15s;
    }
    :host(:hover) {
      border-color: #a0c8f0;
      background: #f7fbff;
    }
    :host([selected]) {
      border-color: #0078d4;
      background: #f0f7ff;
      box-shadow: 0 0 0 2px rgba(0, 120, 212, 0.15);
    }

    .layout {
      display: flex;
      align-items: flex-start;
      gap: 10px;
    }

    .logo {
      flex-shrink: 0;
      width: 32px;
      height: 32px;
      border-radius: 6px;
      background: #f0f3f7;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }
    .logo img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .body {
      flex: 1;
      min-width: 0;
    }

    .name {
      font-size: 13px;
      font-weight: 600;
      color: #1a2e47;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      min-width: 0;
    }

    .description {
      font-size: 11.5px;
      color: #4a5868;
      margin-top: 4px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  `;
__decorate([
    property({ type: Object })
], NetworkCard.prototype, "network", void 0);
__decorate([
    property({ type: String, attribute: 'logo-url' })
], NetworkCard.prototype, "logoUrl", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], NetworkCard.prototype, "selected", void 0);
NetworkCard = __decorate([
    customElement('network-card')
], NetworkCard);
export { NetworkCard };
//# sourceMappingURL=NetworkCard.js.map